import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button, Card, CardContent, Container, Dialog, DialogTitle, Grid, IconButton, TextField, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { Component } from 'react'
import theme from '../../../styles/customTheme';

import { Cell, Pie, ResponsiveContainer, Label, PieChart } from 'recharts';
import Progress from "../graphs/Progress";
import { GradientButton } from '../GradientButton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import EditEnvelope from "./EditEnvelope";
import { updateParentHeight } from "../../../utils/helperFns";
import wyzrTheme from '../../../styles/customTheme';
import axios from 'axios';
import SavingEnvelopeList from './SavingEnvelopeList';

import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';


export class SavingEnvelope extends Component {
    constructor(props) {
        super(props)
        this.DEFAULT_MSG = "Amount should be strictly greater than 0"
        this.state = {
            piedata: [],
            isReady: false,
            showEditEnvelope: false,
            selectedGoal: 0,
            disable: false,
            goalError: this.DEFAULT_MSG,
            showSavingEnvelopelist: false,
            openDialog: false,
            saved_so_far: 0,
            showWithdrawLoader: false,
            showTopupLoader: false,
            open: false,
            msg: "",
            img: "success.gif"
        }
    }




    toggleOpen = (msg, secondMsg=null, img="success.gif") => {
        this.setState({ open: !this.state.open, msg: msg, secondMsg: secondMsg, img: img });
    }
    handleBoxClose = () => {
        this.setState({ open: false });
    };

    handleClickOpen = async () => {
        if (this.state.selectedGoal > this.state.saved_so_far) {
            this.setState({
                goalError: "Amount is more than you have available to withdraw"
            }, () => this.props.updateParentHeight())
            return;
        } else if (this.state.selectedGoal <= 0) {
            this.setState({
                goalError: "Amount should be more than 0"
            }, this.props.updateParentHeight)
            return;
        }
        this.setState({ disable: true, showWithdrawLoader: true });
        await this.delay(2000);
        this.setState({ openDialog: true })
    };

    handleClose = (value) => {
        this.setState({ openDialog: false })
        this.setState({ disable: false, showWithdrawLoader: false });

    };
    componentDidMount() {
        if (!this.state.isReady)
            this.processData({
                debit: {
                    "more to save": this.props.envelope.target - this.props.envelope.saved,
                },
                credit: {
                    "saved so far": this.props.envelope.saved,
                }
            });
    }


    inputHandler = (value) => {
        this.setState({ goalError: null, selectedGoal: value }, () => { this.props.updateParentHeight() });
    }

    processData = (response) => {
        let textdata = response.text;
        let piedata = [];

        let d = new Map(Object.entries(response.debit));
        let c = new Map(Object.entries(response.credit));
        let total = 0;
        for (const [k, v] of d.entries()) {
            piedata.push({ name: k, value: v });
            total += v;
        }

        for (const [k, v] of c.entries()) {
            piedata.push({ name: k, value: v });
            total += v;
        }

        this.setState({
            piedata: piedata,
            textdata: textdata,
            total: total,
            isReady: true,
            saved_so_far: piedata[1].value
        });
    };

    toggleEditEnvelope = (isBack=false) => {
        var show = this.state.showEditEnvelope;
        show = !show;
        this.setState({ showEditEnvelope: show },
            () => {
                updateParentHeight("child_SavingEnvelope", "child_EditEnvelope", this.state.showEditEnvelope, "parent_SavingEnvelopes");
                if (!show && !isBack) {
                    this.toggleOpen("This action will be completed soon. Look out for an email!")

                    setTimeout(() => {
                        this.toggleOpen("");
                    }, 6251);
                }
            });
    }

    toggleSavingEnvelopelist = async (withdraw_btn = false) => {
        if (withdraw_btn) {
            this.setState({ disable: true, showWithdrawLoader: true });
            await this.delay(2000);
            this.setState({ disable: false, showWithdrawLoader: false });

        }
        var show = this.state.showSavingEnvelopelist;
        show = !show;
        this.setState({ showSavingEnvelopelist: show },
            () => {
                updateParentHeight("child_SavingEnvelope", "child_SavingEnvelopeList", this.state.showSavingEnvelopelist, "parent_SavingEnvelopes");
            });
        // this.setState({ selectedGoal: 0 });

    }

    convertToDays = (x) => {
        let splited_x = x.split(" ")
        let unit = parseFloat(splited_x[0]);
        let type = splited_x[1];

        let days;
        if (type) {

            if (type.includes("week")) {
                days = unit * 7;
            }
            else if (type.includes("month")) {
                days = unit * 30;
            }
            else if (type.includes("year")) {
                days = unit * 365;
            } else {
                days = unit
            }

            return days;
        } else {
            return days
        }
    }

    // create function to add delay
    delay = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    onDelete = async () => {
        this.setState({ disable: true });

        axios.post('https://5xzfhwwvk3.execute-api.eu-west-2.amazonaws.com/v1/deleteenvelope', {
            gid: this.props.gid,
            // amount: this.state.selectedGoal,
            env: this.props.envelope.env_id
        }).then(res => {
            console.log("Delete response -->", res);
        }
        ).catch(err => {
            console.log(err);
        }
        ).finally(() => { this.setState({ disable: false }) });

        this.toggleOpen("This action will be completed soon.", "Look out for an email!");
            // toggle open again after 3 seconds
            setTimeout(() => {
                this.toggleOpen();
                this.props.toggleHandler(true)
            }
                , 6251);
    }



    onTopUp = async () => {
        if (this.state.selectedGoal >= this.props.max_save) {
            this.setState({
                goalError: "Amount is more than current account balance available for Top Up"
            }, () => this.props.updateParentHeight())
            return;
        } else if (this.state.selectedGoal <= 0) {
            this.setState({
                goalError: "Amount should be more than 0"
            }, () => this.props.updateParentHeight())
            return;
        }

        this.setState({ disable: true, showTopupLoader: true });
        await this.delay(2000);

        console.log("CALLING SWEEP")
        axios.post('https://5xzfhwwvk3.execute-api.eu-west-2.amazonaws.com/v1/transfer_from_sweep', {
            gid: this.props.gid,
            amount: this.state.selectedGoal,
            env: this.props.envelope.env_id
        }).then(res => {
            console.log("Topup response -->", res);
            const is_failed = res.data.status == "failed";
            this.handleClose();
            if (is_failed) {
                this.toggleOpen("This operation cannot be completed at ","this time as your earlier operation is in progress.", "error.png")

            } else {
                this.toggleOpen("Top up transaction successfully posted.", " This action will be completed soon. Look out for an email!");
            }

            setTimeout(() => {
                this.toggleOpen("");
            }, 6251);
           
        }
        ).catch(err => {
            console.log(err);
        }
        );
        // }
        
        // toggle open again after 3 seconds
        this.setState({ disable: false, goalError: null, showTopupLoader: false }, () => this.props.updateParentHeight());

    }

    handleEnvelopesOnClick = async () => {
        this.handleClose();
        this.toggleSavingEnvelopelist();

    }

    onSweepAccountClick = () => {
        axios.post('https://5xzfhwwvk3.execute-api.eu-west-2.amazonaws.com/v1/withdraw_to_sweep', {
            gid: this.props.gid,
            amount: this.state.selectedGoal,
            env: this.props.envelope.env_id,
        }).then(res => {
            console.log("Withdraw to sweep response -->", res.data);
            const is_failed = res.data.status == "failed";
            this.handleClose();
            if (is_failed) {
                this.toggleOpen("This operation cannot be completed at ","this time as your earlier operation is in progress.", "error.png")

            } else {
                this.toggleOpen("This action will be completed soon.", "Look out for an email!")
            }

            setTimeout(() => {
                this.toggleOpen("");
            }, 6251);
           
            // this.setState({ selectedGoal: 0 });
        }
        ).catch(err => {
            console.log(err);
        });
    }

    loader = () => {
        return (
            <img src="/loader.gif" height="25" alt=""/>
        )
    }

    render() {
        const InfoDialog = () => (
            <Dialog onClose={this.handleClose} open={this.state.openDialog}>

                <DialogTitle sx={{ margin: 0 }}>Withdraw to</DialogTitle>
                <Divider light />
                <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                    <Button variant="outlined" size="small" sx={{ marginX: 2, paddingX: 5 }} onClick={this.onSweepAccountClick}>
                        Sweep Account
                    </Button>
                    <Button variant="outlined" size="small" sx={{ marginX: 2, paddingX: 5 }} onClick={this.handleEnvelopesOnClick}>
                        Envelopes
                    </Button>
                </CardContent>
            </Dialog>
        );

        const CenterLabel = ({ viewBox, amount = 0 }) => {
            const { cx, cy } = viewBox;
            return (
                <React.Fragment>
                    <text x={cx} y={2.2 * cy} textAnchor="middle" dominantBaseline="central" style={{ fill: wyzrTheme.palette.success.main, fontSize: "2rem", fontWeight: 700 }} >
                        {(this.props.envelope.saved / this.props.envelope.target * 100).toFixed(2)}%
                    </text>
                    <text x={cx} y={cy - 10} textAnchor="middle" dominantBaseline="central">
                        <tspan
                            style={{
                                fontWeight: 700,
                                fontSize: "1rem",
                                fontFamily: "Nunito Sans",
                            }}
                        >
                            £{amount}
                        </tspan>
                        <br />
                    </text>
                    <text x={cx} y={cy + 10} textAnchor="middle" dominantBaseline="central">
                        <tspan
                            style={{
                                fontWeight: 700,
                                fontSize: "1rem",
                                fontFamily: "Nunito Sans",
                                fill: 'grey'
                            }}
                        >
                            target
                        </tspan>
                    </text>
                </React.Fragment>
            );
        };
        const COLORS = [theme.palette.grey[300], theme.palette.success.main];
        const renderCustomizedLabel = ({
            cx,
            cy,
            midAngle,
            innerRadius,
            outerRadius,
            name,
            value,
        }) => {
            const RADIAN = Math.PI / 180;
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            const fx = x > cx ? x + 20 : x - 20;
            const fy = y > cy ? y + 20 : y - 20;
            return (
                <>
                    <text
                        x={fx}
                        y={fy}
                        fill="black"
                        className={`recharts-text recharts-label chart-label ${name === "saved so far" ? "chart-label-big" : "chart-label-small"}`}
                        textAnchor={fx > cx ? "start" : "end"}
                        dominantBaseline="central"
                    >
                        £{value}
                        <tspan
                            x={fx}
                            y={name === "saved so far" ? fy + 25 : fy + 16}
                            style={{
                                fontSize: "1rem",
                                fontWeight: "700",
                                display: "block",
                                fontFamily: "Nunito Sans",
                                padding: "0.6rem 1.6rem",
                                fill: 'grey'
                            }}
                        >
                            {name}
                        </tspan>
                    </text>
                </>
            );
        };



        return (
            <>
                <Card className="popup" id="child_SavingEnvelope">
                    <Grid>
                        <Box className="popupClose">
                            <IconButton aria-label="Close" onClick={() => this.props.toggleHandler(true)}>
                                <ArrowBack />
                            </IconButton>
                        </Box>


                        <Box display={{ xs: "none", sm: "block" }} position="absolute" top={0} right={0} p={2} zIndex={20}>
                            <Button variant="outlined" size="small" onClick={this.toggleEditEnvelope} startIcon={<EditIcon />}>
                                Edit Goal
                            </Button>
                            <Button onClick={this.onDelete} disabled={this.state.disable} variant="outlined" size="small" color="error" sx={{ borderRadius: "0.7rem", marginX: "0.5rem" }}>
                                Delete Envelope
                            </Button>
                        </Box>


                        <Box className="popupHeader">
                            <img src={this.props.envelope.icon} width={40} height={40} style={{ display: "block", margin: "auto" }} alt=""/>
                            <Typography gutterBottom align="center" variant="h4" sx={{ display: "block", marginBottom: 2, textTransform: "capitalize" }}>
                                {this.props.envelope.category} envelope
                            </Typography>
                            <Divider light />

                        </Box>
                        <Box className="popupBody" pt={{ xs: 12, sm: 0 }}>

                            <Box display={{ xs: "block", sm: "none" }} textAlign="center" mt={2}>
                                <Button variant="outlined" size="small" onClick={this.toggleEditEnvelope} startIcon={<EditIcon />}>
                                    Edit Goal
                                </Button>
                                <Button onClick={this.onDelete} disabled={this.state.disable} variant="outlined" size="small" color="error" sx={{ borderRadius: "0.7rem", marginX: "0.5rem" }}>
                                    Delete Envelope
                                </Button>
                            </Box>
                            <CardContent textAlign="center" className="flex-center-all" mt={3} sx={{ alignItems: "flex-start !important" }}>
                                <Grid position="relative" container columnSpacing={2} className="paddingContainer" mt={2} justifyContent="center">
                                    <Grid item sm={12} md={5}>
                                        <Box className="flex-center-all" sx={{ flexDirection: "column" }}>
                                            <Typography gutterBottom align="center" variant="h5">
                                                {this.props.envelope.data.heading1}
                                            </Typography>
                                            <Typography gutterBottom align="center" color="text.secondary" variant="body2">
                                                {this.props.envelope.data.subheading}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Container className="chartContainer" >
                                                <ResponsiveContainer>
                                                    <PieChart>
                                                        <Pie
                                                            data={this.state.piedata}
                                                            label={renderCustomizedLabel}
                                                            labelLine={false}
                                                            outerRadius="95%"
                                                            innerRadius="75%"
                                                            fill="#8884d8"
                                                            paddingAngle={0}
                                                            dataKey="value"
                                                            verticalAlign="center"
                                                            startAngle={210}
                                                            endAngle={-150}
                                                        >
                                                            <Label
                                                                content={<CenterLabel amount={this.state.total} />}
                                                                position="center"
                                                            />
                                                            {this.state.piedata.map((entry, index) => (
                                                                <Cell fill={COLORS[index % COLORS.length]} />
                                                            ))}
                                                        </Pie>
                                                        <Tooltip />
                                                    </PieChart>
                                                </ResponsiveContainer>
                                            </Container>
                                            <Box sx={{ marginTop: "3rem", px: "0.4rem" }}>
                                                <Progress
                                                    width="100%"
                                                    prefix={' '}
                                                    startText={this.props.envelope.days_elapsed + " gone"}
                                                    endText={this.props.envelope.days_to_go + " to go"}
                                                    startNumber={this.convertToDays(this.props.envelope.days_elapsed)}
                                                    endNumber={this.convertToDays(this.props.envelope.days_to_go)}
                                                    showNumbers={"false"}
                                                    color={theme.palette.primary.light}
                                                />
                                            </Box>
                                        </Box>
                                        <Grid container marginTop={3}>

                                            <TextField
                                                onChange={(event) => this.inputHandler(event.target.value)}
                                                sx={{ marginTop: "-1rem", marginBottom: "1rem", width: "100%", textAlign: "center" }}
                                                InputProps={{
                                                    inputProps: {
                                                        min: 0,
                                                        max: this.props.envelope.target
                                                    }
                                                }} className="inputBig inputIcon" defaultValue={this.state.selectedGoal} type="number" variant="standard" />
                                            {
                                                this.state.goalError ?
                                                    <Typography variant='caption' color={wyzrTheme.palette.error.light} sx={{ whiteSpace: "nowrap", textOverflow: "ellipsis", margin: "auto" }}>{this.state.goalError}</Typography> : null
                                            }

                                            <Grid justifyContent="space-between" alignItems={"center"} container marginTop={2}>

                                                <Grid item xs={5}>
                                                    <GradientButton fullWidth sx={{ borderRadius: "0.7rem !important", textTransform: "capitalize" }} onClick={this.onTopUp} disabled={this.state.disable || this.state.selectedGoal === 0}>
                                                        {this.state.showTopupLoader ? this.loader() : "Top up Envelope"}

                                                    </GradientButton>
                                                </Grid>
                                                <Grid item xs={5} sx={{ minWidth: "50% !important" }}>
                                                    <Button fullWidth variant="outlined" color="error" sx={{ borderRadius: "0.7rem" }} onClick={this.handleClickOpen} disabled={this.state.disable || this.state.selectedGoal === 0}>
                                                        {this.state.showWithdrawLoader ? this.loader() : "Transfer to other envelopes"}

                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item md={1} display={{ xs: "none", md: "block" }}>
                                        <Divider orientation="vertical" light />
                                    </Grid>

                                    <Grid item md={6} mt={{ xs: 4, md: 0 }}>
                                        <Typography gutterBottom align="center" variant="h5">
                                            {this.props.envelope.data.heading2}
                                        </Typography>

                                        <Grid container columnSpacing={2} mt={4}>
                                            <Grid item sm={6} xs={8} margin={"auto"} sx={{ display: "flex", justifyContent: "center" }}>
                                                <Stack rowGap={3}>
                                                    {
                                                        this.props.envelope.data.boxes.map((item, index) => (
                                                            <Box width="100%" textAlign="center" px={3} py={2} sx={{ borderRadius: "10px" }} boxShadow={3}>
                                                                <Typography variant="h6">{item.heading}</Typography>
                                                                <Typography variant="caption" color="text.secondary">{item.subheading}</Typography>
                                                            </Box>
                                                        ))
                                                    }
                                                </Stack>
                                            </Grid>

                                        </Grid>

                                    </Grid>
                                </Grid>

                            </CardContent>
                        </Box>
                    </Grid>

                    {this.state.showEditEnvelope ?
                        <EditEnvelope
                            gid={this.props.gid}
                            envelope={this.props.envelope}
                            parent="child_SavingEnvelope"
                            toggleHandler={this.toggleEditEnvelope} />
                        : null
                    }
                    {
                        this.state.showSavingEnvelopelist ?
                            <SavingEnvelopeList
                                toggleHandler={this.toggleSavingEnvelopelist}
                                amount={this.state.selectedGoal}
                                gid={this.props.gid}
                                parent="child_SavingEnvelope"
                                env_id={this.props.envelope.env_id}
                            />
                            : null
                    }

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleBoxClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        sx={{ borderRadius: "30px" }}
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" className="font-medium">
                                <img src={`/${this.state.img}`} style={{ display: "block", margin: "auto" }} alt=""/>
                                <p style={{ marginTop: "-20px", margin: "auto", textAlign: "center", fontWeight: 900 }}>{this.state.msg}{
                                    this.state.secondMsg ? (<><br /> {this.state.secondMsg} </>) : null
                                }</p>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                </Card>
                <InfoDialog
                    open={this.state.openDialog}
                    onClose={this.handleClose}
                />
            </>
        )
    }
}

export default SavingEnvelope
